<template>
  <div class="mt-2 text-left flex gap-2 items-center box-border w-full">
    <div
      class="h-full sm:w-10/12 w-11/12 border border-gray-500 rounded-lg text-xs md:text-sm flex flex-row gap-2 items-center py-1"
    >
      <img
        src="@/assets/icons/file-document.svg"
        alt="icono blanco de documento"
        class="h-5 my-auto mr-2 pl-5"
      />
      <p class="text-xs text-gray-500 truncate">{{ value }}</p>
    </div>
    <button
      class="h-full sm:w-44 w-24 rounded-md h-10 sm:mx-auto mx-0 sm:px-5 mt-auto hover:bg-blue-500 general-color-button flex flex-row justify-center items-center"
      @click="viewModal"
    >
      <span class="text-xs text-white hidden sm:block">{{ legend }}</span>
    </button>
    <span class="text-red-500 text-left">{{ this.feedback }}</span>
    <div>
      <a-modal
        v-model="opened"
        centered
        shape="round"
        :footer="null"
        :width="'50%'"
      >
        <a-row class="h-full no-print">
          <iframe
            v-if="
              typeMime && typeMime !== '' && typeMime.includes('application')
            "
            class="w-full h-96"
            :src="
              'https://docs.google.com/gview?url=' +
              encodeURIComponent(url_download) +
              '&embedded=true'
            "
          >
          </iframe>

          <div class="zoomer-flex" v-if="typeMime && typeMime !== '' && typeMime.includes('image')">
            <div class="zoomer-center mb-4">
              <v-zoomer
                class="v-zoomer"
                :zoomed.sync="isZoomed"
                :class="{ 'is-zoomed': isZoomed }"
                style="width: 420px; height: 420px; border: solid 1px silver"
              >
                <img
                  :src="url_download"
                  style="object-fit: contain; width: 100%; height: 100%"
                />
              </v-zoomer>
            </div>
            <p class="text-center">Use la rueda del ratón para hacer zoom</p>
          </div>

          <button
            @click="closeModal"
            class="w-full border-2 text-white bg-blue-500 rounded-3xl py-2 px-8 mt-6"
          >
            Cerrar
          </button>
        </a-row>
      </a-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: ["label", "value", "url_download", "typeMime"],
  data() {
    return {
      isZoomed: false,
      loading: false,
      feedback: "",
      legend: "Previsualizar",
      opened: false,
    };
  },
  methods: {
    viewModal() {
      this.opened = true;
    },
    closeModal() {
      this.opened = false;
    },
  },
  computed: {},
};
</script>

<style>
@media print {
  .no-print {
    display: none !important;
  }
}

.zoomer-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.zoomer-center {
  display: flex;
  justify-content: center;
}

.v-zoomer {
  cursor: grab; /* Mano abierta cuando se puede hacer zoom */
}

.v-zoomer.is-zoomed {
  cursor: grabbing; /* Mano cerrada cuando se puede mover la imagen */
}

.loader {
  width: 25px;
  height: 25px;
  border: 3px solid #3366cc;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  position: absolute;
  left: 50%;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
